import React, { Component } from 'react'
import List from '../../old_Components/Campus/InternsipApplicationList';
import constant from '../../constant';
import queryString from 'query-string';
import { capitalizeWords } from '../../utils';
import OffCampusInternshipApplicationList from '../../old_Components/Campus/OffCampusInternshipApplicationList';
export default class JobApplicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LIMIT: 10,
      PAGE: 1,
      SELECTION_PROCESS: undefined,
      COUNT: undefined,
      LIST: undefined,
      KEYWORD: '',
      JOB_TITLE: '',
      status: undefined,
      ATS_ENABLED: 0,
      CURRENT_TAB: 'on_campus'

    }
  }

  componentDidMount() {
    const qParam = queryString.parse(this.props?.location?.search)
    this.setState({ JOB_TITLE: capitalizeWords(qParam.job.split('-')).join(' '), SELECTION_PROCESS: qParam.s })
    document.title = capitalizeWords(qParam.job.split('-')).join(' ') + ' Applications - Hiring.JobzShala.com'
    this.setState({
      FILTER_BY: qParam.f,
      PAGE: qParam.p,
      LIMIT: qParam.l,
      KEYWORD: qParam.k,
      CURRENT_TAB: qParam.t ? qParam.t : 'on_campus',
    })

  }

  onLimitChange = (input) => {
    const qParam = queryString.parse(this.props?.location?.search)
    window.location.href = constant.component.CampusInternshipApplicationList.url + `?job=${qParam.job}&id=${qParam.id}&l=${input}&p=${qParam.p}&s=${qParam.s}&t=${qParam.t ? qParam.t : 'on_campus'}`
  }
  onPageChange = (input) => {
    const qParam = queryString.parse(this.props?.location?.search)
    window.location.href = constant.component.CampusInternshipApplicationList.url + `?job=${qParam.job}&id=${qParam.id}&l=${qParam.l}&p=${input}&s=${qParam.s}&t=${qParam.t ? qParam.t : 'on_campus'}`
  }

  onTabChange = (tab) => {
    debugger
    const qParam = queryString.parse(this.props?.location?.search)
    window.location.href = constant.component.CampusInternshipApplicationList.url + `?job=${qParam.job}&id=${qParam.id}&l=${qParam.id}&p=${qParam.p}&s=${qParam.s}&t=${tab}`
  }
  render() {
    const { JOB_TITLE, CURRENT_TAB } = this.state
    const qParam = queryString.parse(this.props?.location?.search)
    return (
      <React.Fragment>

        {CURRENT_TAB === 'on_campus' ? <List
          PAGE={qParam.p}
          LIMIT={qParam.l}
          SELECTION_PROCESS={qParam.s}
          KEYWORD={qParam.k}
          JOB_ID={qParam.id}
          JOB_TITLE={JOB_TITLE}
          onTabChange={(tab) => this.onTabChange(tab)}
          onLimitChange={(limit) => this.onLimitChange(limit)}
          onPageChange={(page) => { this.onPageChange(page) }}
        /> : <OffCampusInternshipApplicationList
          PAGE={qParam.p}
          LIMIT={qParam.l}
          SELECTION_PROCESS={qParam.s}
          KEYWORD={qParam.k}
          JOB_ID={qParam.id}
          JOB_TITLE={JOB_TITLE}
          onTabChange={(tab) => this.onTabChange(tab)}
          onLimitChange={(limit) => this.onLimitChange(limit)}
          onPageChange={(page) => { this.onPageChange(page) }}
        />}
      </React.Fragment>
    )
  }
}
